export default "__VITE_ASSET__DuQdEGvg__"